import type { WithStyleOverrides, WithTheme } from '../../gem'

export enum Status {
  Invalid,
  /**
   * This is specifically provided to avoid layout shifts when
   * `alwaysVisibleWhenActive` is `false`. It should only be used in that
   * context, and only when necessary: if toggling the status indicator's
   * visibility won't affect layout, don't use this `Status`.
   */
  Invisible,
  RequiredButNotValidated,
  Pending,
  Valid,
}

export type WithStatus = Readonly<{
  status?: Status
}>

export type StatusIndicatorProps = Readonly<
  WithTheme &
    WithStatus &
    WithStyleOverrides & {
      /**
       * If `false`, the indicator won't be displayed. This is useful for things
       * like labels on text inputs, where we only want to display the indicator if
       * the user has modified the associated input and that input is invalid.
       */
      active?: boolean
      /**
       * Whether the indicator is always visible, or only visible when indicating
       * something that is invalid or missing.
       */
      alwaysVisibleWhenActive?: boolean
    }
>

export type StyleProps = Required<
  Omit<StatusIndicatorProps, 'active' | 'styleOverrides'>
>
